import { render, staticRenderFns } from "./GroupDeposit.vue?vue&type=template&id=dceda7f0&"
import script from "./GroupDeposit.vue?vue&type=script&lang=js&"
export * from "./GroupDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports